export default "__VITE_PUBLIC_ASSET__7b105b47__"